/**
 * 活动来源类型（纯枚举，无 i18n 等依赖，可供路由等提前加载场景使用）
 */
export const ACTIVITY_ORIGIN_TYPE = {
  /** 路演 common.noun.roadshow */
  ROADSHOW: 1,
  /** 调研 common.noun.research */
  RESEARCH: 2,
  /** 策略会 common.noun.strategy */
  STRATEGY: 3
};
